import { TableHeaderConfigWithType } from '../../../components/_EOS/Table'
import {  
  WorkOrderInBoundGrid
} from '../../../interfaces/WorkOrder/WorkOrder'
import { utcToLocal } from '../../../utils/dateHelper'

export const getHeaderConfigHeaders: () => TableHeaderConfigWithType<WorkOrderInBoundGrid>[] =
  () => {
    return [
      { field: 'asnId', title: 'ID ASN', sortable: true },
      { field: 'asnNumber', title: 'Nro ASN', sortable: true },
      {
        field: 'receivedDate',
        title: 'Fecha Recepción',
        formater: (_id, row) =>
          utcToLocal(row?.receivedDate || '', 'dd/MM/yyyy'),
        sortable: true
      },
      { field: 'supplierName', title: 'Nombre o razón social', sortable: true },      
      { field: 'unitsQty', title: 'C. En ASN', sortable: true },
      { field: 'locatedQty', title: 'C. Recibido', sortable: true },
      { field: 'differenceQty', title: 'C. Pendiente Por Ajustar', sortable: true }

    ]
  }
